import React, {useState} from 'react'
import PropTypes from 'prop-types'
import {
    Stack,
    useStyleConfig,
    Box,
    Text
} from '@salesforce/retail-react-app/app/components/shared/ui'
import {FormattedMessage} from 'react-intl'
import useGiftcardFields from './useGiftcardFields'
import Field from '../field'

const EGiftCardFields = ({form, prefix = ''}) => {
    const [charactersRemaining, setCharactersRemaining] = useState(200)
    const fields = useGiftcardFields({form, prefix, setCharactersRemaining})
    const styles = useStyleConfig('GiftCertificate')
    return (
        <Stack gap="0px" className="egiftcard-fields-stack">
            <Box {...styles.rightBox.form.fields.personBox} className="egiftcard-from-box">
                <Text {...styles.rightBox.form.fields.labelColor}>
                    <FormattedMessage defaultMessage="From" id="eGiftcard.product.from" />
                </Text>
                <Box {...styles.rightBox.form.fields.fieldBox} marginBottom="30px">
                    <Field {...fields.fromFirstName} />
                    <Field {...fields.fromLastName} />
                </Box>
            </Box>
            <Box {...styles.rightBox.form.fields.personBox} className="egiftcard-to-box">
                <Text {...styles.rightBox.form.fields.labelColor}>
                    <FormattedMessage defaultMessage="To" id="eGiftcard.product.to" />
                </Text>
                <Box {...styles.rightBox.form.fields.fieldBox}>
                    <Field {...fields.toFirstName} />
                    <Field {...fields.toLastName} />
                </Box>
                <Field {...fields.email} />
                <Field {...fields.confirmEmail} />
                <Text {...styles.rightBox.form.fields.labelColor}>
                    <FormattedMessage
                        defaultMessage="Personalized Message"
                        id="eGiftcard.product.personalizedMessage"
                    />
                </Text>
                <Field {...fields.personalizedMessage} />
                <Text {...styles.rightBox.charactersRemaining}>
                    <FormattedMessage
                        id="characters.left"
                        defaultMessage="{charsRemaining} characters left."
                        values={{
                            charsRemaining: charactersRemaining
                        }}
                    />
                </Text>
            </Box>
        </Stack>
    )
}

EGiftCardFields.propTypes = {
    /** Object returned from `useForm` */
    form: PropTypes.object.isRequired,

    /** Optional prefix for field names */
    prefix: PropTypes.string
}

export default EGiftCardFields
